<template>
  <div class="bg-default">
    <!-- Navbar -->
    <nav
      id="navbar-main"
      class="navbar navbar-horizontal navbar-transparent navbar-main navbar-expand-lg navbar-light"
    >
      <div class="container">
        <a class="navbar-brand" href="/">
          <img
            src="/assets/img/icons/pointograph-logo-white.svg"
            alt="pointograph logo"
          />
        </a>
        <!--
        <button
          class="navbar-toggler"
          type="button"
          data-toggle="collapse"
          data-target="#navbar-collapse"
          aria-controls="navbar-collapse"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span class="navbar-toggler-icon"></span>
        </button>
        <div
          class="navbar-collapse navbar-custom-collapse collapse"
          id="navbar-collapse"
        >
          <div class="navbar-collapse-header">
            <div class="row">
              <div class="col-6 collapse-brand">
                <a href="dashboard.html">
                  <img src="/assets/img/brand/blue.png" />
                </a>
              </div>
              <div class="col-6 collapse-close">
                <button
                  type="button"
                  class="navbar-toggler"
                  data-toggle="collapse"
                  data-target="#navbar-collapse"
                  aria-controls="navbar-collapse"
                  aria-expanded="false"
                  aria-label="Toggle navigation"
                >
                  <span></span>
                  <span></span>
                </button>
              </div>
            </div>
          </div>
        </div> -->
      </div>
    </nav>
    <!-- Main content -->
    <div class="main-content">
      <!-- Header -->
      <div class="header bg-gradient-primary py-7 py-lg-8 pt-lg-9">
        <div class="separator separator-bottom separator-skew zindex-100">
          <svg
            x="0"
            y="0"
            viewBox="0 0 2560 100"
            preserveAspectRatio="none"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
          >
            <polygon
              class="fill-default"
              points="2560 0 2560 100 0 100"
            ></polygon>
          </svg>
        </div>
      </div>
      <!-- Page content -->
      <div class="container mt--8 pb-5">
        <div class="row justify-content-center">
          <div class="col-lg-5 col-md-7">
            <div class="card bg-secondary border-0 mb-0">
              <div class="card-body px-lg-5 py-lg-5">
                <div class="text-center text-muted mb-4">
                  <p>Sign in</p>
                </div>
                <form @submit.prevent="login">
                  <div class="form-group mb-3">
                    <div
                      class="input-group input-group-merge input-group-alternative"
                    >
                      <div class="input-group-prepend">
                        <span class="input-group-text"
                          ><i class="ni ni-email-83"></i
                        ></span>
                      </div>
                      <input
                        class="form-control"
                        placeholder="Email"
                        v-model="email"
                        :readonly="loading"
                        type="email"
                        required
                      />
                    </div>
                  </div>
                  <div class="form-group">
                    <div
                      class="input-group input-group-merge input-group-alternative"
                    >
                      <div class="input-group-prepend">
                        <span class="input-group-text"
                          ><i class="ni ni-lock-circle-open"></i
                        ></span>
                      </div>
                      <input
                        class="form-control"
                        placeholder="Password"
                        required
                        v-model="password"
                        :readonly="loading"
                        type="password"
                      />
                    </div>
                  </div>
                  <!-- <div
                    class="custom-control custom-control-alternative custom-checkbox"
                  >
                    <input
                      class="custom-control-input"
                      id=" customCheckLogin"
                      type="checkbox"
                    />
                    <label class="custom-control-label" for=" customCheckLogin">
                      <span class="text-muted">Remember me</span>
                    </label>
                  </div> -->
                  <div class="text-center">
                    <button type="submit" class="btn btn-primary my-4">
                      <span v-if="!loading">Sign in</span>
                      <PulseLoader
                        v-else
                        :color="color"
                        :size="size"
                        :loading="loading"
                      ></PulseLoader>
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Login',
  data () {
    return {
      email: 'admin@pointograph.com',
      password: 'password',
      color: '#fff',
      size: '12px',
      loading: false
    }
  },
  methods: {
    async login () {
      const { email, password } = this
      this.loading = true
      try {
        const res = await this.$store.dispatch('auth/login', {
          email,
          password
        })
        if (!res) return
        this.loading = false
        this.$toastr.s('successfully logged in')
        this.$router.push('/dashboard')
      } catch (error) {
        this.loading = false
        console.log(error)
      }
    }
  }
}
</script>

<style scoped>
.bg-gradient-primary {
  background: transparent !important;
}
.bg-default {
  height: 100vh;
}
@media (max-width: 768px) {
  .main-content {
    padding-top: 60px;
  }
}
</style>
